<!--  -->
<template>
  <div class="businessOrder">
    <common-title titleName="订单快递查询" :zIndex="1000"></common-title>
    <div class="search">
      <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/search.png" alt="" />
      <input @input="change()" v-model="orderId" placeholder="请输入订单号" />
      <button @click="search()">搜索</button>
    </div>
    <div v-if="orderList.length" class="order-list">
      <OrderCard
        @lookLogistics="lookLogistics"
        v-for="(item, index) in orderList"
        :key="index"
        :cardInfo="item"
      />
    </div>
    <div><EmptyData v-if="!orderList.length" :emptyName="'businessOrder'" /></div>
    <LogisticsDetail :showDetail="showDetail" :logistics="expressDetail" @close="close" />
    <LinkMini/>
  </div>
</template>

<script>
import { reqWdtExpress, reqLogisticsDetail } from '@/api/businessOrder';
import EmptyData from '@/components/emptyData/emptyData.vue';
import LogisticsDetail from './component/logisticsDetail.vue';
import OrderCard from './component/orderCard.vue';
import LinkMini from './component/linkMini'

export default {
  components: {
    OrderCard,
    EmptyData,
    LogisticsDetail,
    LinkMini
  },
  data() {
    return {
      orderId: '',
      orderList: [],
      expressDetail: {},
      showDetail: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    change() {
      this.orderId = this.orderId.replace(/\s*/g, '');
    },
    async search() {
      if (!this.orderId) {
        this.$toast('请输入快递单号');
        return;
      }
      this.getExpressList(this.orderId);
    },
    async getExpressList(orderId) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 0,
      });
      const { data } = await reqWdtExpress(orderId);
      this.orderList = data || [];
      this.$toast.clear();
    },
    lookLogistics(expressNo,addresseePhone) {
      this.getLogicsticsDetail(expressNo,addresseePhone);
    },
    async getLogicsticsDetail(expressNo,addresseePhone) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 0,
      });
      const { code, msg, data } = await reqLogisticsDetail({expressNo,addresseePhone});
      this.$toast.clear();
      if (code === 0) {
        this.showDetail = true;
        this.expressDetail = data;
      } else {
        this.$toast(msg);
      }
    },
    close() {
      this.showDetail = false;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.businessOrder {
  padding: 100px 0 0 0;
  .search {
    position: relative;
    padding: 40px 40px;
    background: #fff;
    img {
      position: absolute;
      top: 68px;
      left: 64px;
      width: 24px;
      height: 24px;
    }
    input {
      width: 100%;
      height: 80px;
      padding-left: 64px;
      color: #333;
      font-size: 28px;
      background: #f7f8fc;
      border-radius: 44px;
    }
    button {
      position: absolute;
      top: 35px;
      right: 40px;
      width: 120px;
      color: #fff;
      font-weight: 400;
      font-size: 28px;
      line-height: 80px;
      background: #ff7f41;
      border-radius: 44px;
    }
  }
  .order-list {
    padding: 40px;
    padding-bottom: 380px;
  }
}
</style>
